import { Add } from "@mui/icons-material";
import { IFormSection, TSubmitType } from "../../types/common";
import {
  API_INVENTORY_ALL,
  API_PAYMENT_MODES_CONFIGURABLES,
  API_PURCHASE_ORDERS,
} from "../../utils/apis";
import { MODAL } from "../../utils/constants";

import { URL_PURCHASE_ORDERS } from "../../utils/urls";
import useGet from "../common/useGet";
import { useEffect } from "react";
import { getResultOptions } from "../../utils/helpers";

export type TFormCustomProps = {
  id?: number;
  submitType?: TSubmitType;
};

export const usePurchaseOrderForm = ({ form }) => {
  const sections: IFormSection[] = [
    {
      title: "Purchase Information",
      fields: [
        {
          field_name: "supplier",
          type: "select",
          label: "Supplier Name",
          props: { required: true },
          options_name: "suppliers",
        },
        {
          field_name: "purchase_order_date",
          type: "date",
          label: "Purchase Order Date",
          props: { required: true },
        },
        {
          field_name: "payment_type",
          type: "select",
          label: "Payment Type",
          options_name: "payment_modes",
          props: { required: true },
        },

        {
          field_name: "destination_address",
          type: "textarea",
          label: "Destination Address",
          props: { required: true },
        },
      ],
    },
    {
      title: "Order Items",
      fields: [
        {
          field_name: "order_items",
          type: MODAL,
          label: "Add Order Items",
          props: { required: true, icon: <Add fontSize="small" />, wide: true },
          fields: [
            {
              field_name: "existing_inventory",
              type: "select",
              label: "Item",
              props: { required: true },
              options_name: "inventories",
            },
            {
              field_name: "quantity",
              type: "number",
              label: "Quantity",
              props: { required: true },
            },
            {
              field_name: "unit_price",
              type: "number",
              label: "Unit Price",
              props: { required: true },
            },
            {
              field_name: "total_price",
              type: "number",
              label: "Total Price",
              props: {
                required: true,
                disabled: true,
                value: form?.data?.quantity * form?.data?.unit_price,
              },
              visible:
                form.data?.quantity !== undefined &&
                form.data?.unit_price !== undefined,
            },
            {
              field_name: "terms_of_payment",
              type: "textarea",
              label: "Terms of Payment",
            },
            {
              field_name: "description",
              type: "textarea",
              label: "Description",
              props: { required: true },
            },
          ],
        },
      ],
    },
  ];

  const redirect = `${URL_PURCHASE_ORDERS}/submitted`;

  const getConfigOptions = () => {
    const { loadData: getSuppliers, data: suppliers } = useGet();
    const { loadData: getInventory, data: inventory } = useGet();
    const { loadData: getPaymentModes, data: payment_modes } = useGet();
    useEffect(() => {
      getSuppliers({
        api: "configurables/suppliers/",
        params: {},
      });
      getInventory({
        api: API_INVENTORY_ALL,
        params: {},
      });
      getPaymentModes({
        api: API_PAYMENT_MODES_CONFIGURABLES,
        params: { active: true },
      });
    }, []);
    return {
      suppliers: getResultOptions(suppliers, "name", "id"),
      inventories: getResultOptions(inventory, "name", "id"),
      payment_modes: [
        { id: "credit", name: "Credit" },
        ...getResultOptions(payment_modes, "mode", "mode"),
      ],
    };
  };
  const options = {
    ...getConfigOptions(),
  };

  return { sections, redirect, options };
};

export function submitPurchaseOrder(payload: any, id: number | null) {
  //  on update
  if (id) {
    return {
      id,
      api: API_PURCHASE_ORDERS,
      params: payload,
    };
  }
  // on create
  return {
    api: API_PURCHASE_ORDERS,
    params: payload,
  };
}
